import React, { useContext, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import yup from '../../../../libs/yup/yup';
import CustomInput from '../../../../components/input/CustomInput';
import { changePassword, signin } from '../../../../api/sportaloka-client';
import { AuthContext } from '../../../../context/AuthProvider';

const defaultValues = {
  old_password: '',
  password: '',
  password_confirmation: ''
};

const schema = yup.object().shape({
  old_password: yup
    .string()
    .label('Kata sandi sebelumnya')
    .min(8, '${label} Minimal 8 karakter')
    .required('${label} wajib diisi'),
  password: yup
    .string()
    .label('Kata sandi baru')
    .min(8, '${label} Minimal 8 karakter')
    .required('${label} wajib diisi'),
  password_confirmation: yup
    .string()
    .label('Konfirmasi kata sandi baru')
    .required('${label} wajib diisi')
    .oneOf([yup.ref('password'), null], 'Kata sandi tidak cocok')
});

function ChangePasswordForm() {
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useContext(AuthContext);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await changePassword({
        old_password: val.old_password,
        password: val.password
      });

      Swal.fire({
        title: 'Berhasil!',
        text: 'Kata sandi berhasil diubah, semua sesi lain yang aktif saat ini telah dihapus.',
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      reset();
    } catch (error) {
      const errorCode = error.response?.data?.code;
      if (errorCode === '100108') {
        Swal.fire({
          title: 'Gagal!',
          text: 'Kata sandi sebelumnya tidak cocok',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      } else {
        Swal.fire({
          title: 'Gagal!',
          text: 'Periksa koneksi anda dan coba kembali.',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="row y-gap-20" onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="old_password"
        render={({ field: { onChange, onBlur, value } }) => (
          <div className="col-12">
            <CustomInput
              autoComplete="off"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="password"
              label="Kata sandi sebelumnya"
              isError={Boolean(errors.old_password)}
              errorMessage={Boolean(errors.old_password) && errors.old_password.message}
            />
          </div>
        )}
      />

      <Controller
        control={control}
        name="password"
        render={({ field: { onChange, onBlur, value } }) => (
          <div className="col-12">
            <CustomInput
              autoComplete="off"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="password"
              label="Kata sandi baru"
              isError={Boolean(errors.password)}
              errorMessage={Boolean(errors.password) && errors.password.message}
            />
          </div>
        )}
      />

      <Controller
        control={control}
        name="password_confirmation"
        render={({ field: { onChange, onBlur, value } }) => (
          <div className="col-12">
            <CustomInput
              autoComplete="off"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="password"
              label="Konfrimasi kata sandi baru"
              isError={Boolean(errors.password_confirmation)}
              errorMessage={
                Boolean(errors.password_confirmation) && errors.password_confirmation.message
              }
            />
          </div>
        )}
      />

      <div className="col-12 d-flex justify-content-center">
        <button
          disabled={loading}
          type="submit"
          className="button py-20 -dark-1 bg-blue-1 text-white px-20">
          {loading ? 'Mohon tunggu...' : 'Ubah Kata Sandi'}
        </button>
      </div>
    </form>
  );
}

export default ChangePasswordForm;
